import { SelectionModel } from '@angular/cdk/collections';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableDelegate, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { ILegalFormExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { Observable } from 'rxjs';
import { getDebug, getTag } from '../../utils/debugUtil';
import { getLocalizationFromAsyncPipe } from '../../utils/localizationUtils';
import { I18NextService } from 'angular-i18next';

const filename = 'projects/aumico-lib-settings-fe/src/lib/components/legal-form-list/legal-form-list.component.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'aumico-settings-legal-form-list',
    templateUrl: './legal-form-list.component.html',
    styleUrls: ['./legal-form-list.component.scss'],
})
export class LegalFormListComponent implements OnInit, ITableDelegate {
    public options: ITableOptions;
    private rawData: ILegalFormExtendedDTO[];
    public errorMessage: Observable<HttpErrorResponse>;

    @Input() languages: string[] = ['de-ch', 'en-us'];

    @Output()
    public editPressed = new EventEmitter<string>();

    @Input()
    public set data(items: ILegalFormExtendedDTO[]) {
        this.rawData = items;
    }
    public get data(): ILegalFormExtendedDTO[] {
        return this.rawData;
    }

    constructor(private i18nextService: I18NextService) {
        this.prepareFields();
    }

    ngOnInit() {
        this.prepareFields();
    }

    private async prepareFields() {
        this.options = {
            columns: [
                {
                    name: await getLocalizationFromAsyncPipe(this.i18nextService, 'aumico_settings_legalForm_id'),
                    type: 'text',
                    property: '_id',
                },
                {
                    name: await getLocalizationFromAsyncPipe(
                        this.i18nextService,
                        'aumico_settings_legalForm_version',
                    ),
                    type: 'text',
                    property: 'version',
                },
                {
                    name: await getLocalizationFromAsyncPipe(this.i18nextService, 'aumico_settings_legalForm_owner'),
                    type: 'text',
                    property: 'owner',
                },
                {
                    name: await getLocalizationFromAsyncPipe(this.i18nextService, 'aumico_settings_legalForm_name'),
                    type: 'text',
                    property: 'name',
                },
                {
                    name: await getLocalizationFromAsyncPipe(this.i18nextService, 'aumico_settings_legalForm_text'),
                    type: 'translated-text',
                    property: 'text',
                },

                {
                    name: await getLocalizationFromAsyncPipe(this.i18nextService, 'aumico_button_edit'),
                    type: 'button',
                    property: '_id',
                    action: 'edit',
                },
            ],
        };
    }

    public onRowButtonClicked(id: string, action?: string): void {
        debug(`1 Row with Id ${id} clicked for action ${action}`);

        if (action === 'edit') {
            this.editPressed.emit(id);
        }
    }

    onMenuItemClick(action: string, selectedRows: SelectionModel<any>) {
        debug('onMenuItemClick', action, selectedRows);
    }
}
